<script lang="ts" module>
	import Modal from "@components/common/Modal.svelte";
	import { CartModalKind } from "@core/schema/CartModalKind.js";
	import { Locale, type LocalizedString } from "@core/schema/Locale.js";
	import { cartModalComponentMap } from "./cart-modal/cartModalComponentMap.js";

	const cartModalHeadingMap: Record<CartModalKind, LocalizedString> = {
		[CartModalKind.OrderError]: {
			[Locale.cs]: "Chyba",
			[Locale.en]: "Error",
		},
		[CartModalKind.OrderAlreadyExists]: {
			[Locale.cs]: "Objednávka už existuje",
			[Locale.en]: "Order already exists",
		},
		[CartModalKind.ClearForSubscription]: {
			[Locale.cs]: "Objednávka předplatného",
			[Locale.en]: "Subscription order",
		},
		[CartModalKind.ClearForProducts]: {
			[Locale.cs]: "Přidat produkt",
			[Locale.en]: "Add product",
		},
		[CartModalKind.ClearForCourseOrder]: {
			[Locale.cs]: "Přihláška na kurz",
			[Locale.en]: "Course registration",
		},
		[CartModalKind.ClearForPreorder]: {
			[Locale.cs]: "Jiný termín odeslání",
			[Locale.en]: "Different shipping date",
		},
		[CartModalKind.FfcMembersOnly]: {
			[Locale.cs]: "Pouze pro členy Father’s Family Club",
			[Locale.en]: "Father’s Family Club members only",
		},
		[CartModalKind.VouchersRemoved]: {
			[Locale.cs]: "Poukaz odebrán",
			[Locale.en]: "Voucher removed",
		},
	};
</script>

<script lang="ts">
	import { Cart } from "../cart/Cart.svelte.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";

	const { tenant } = getGlobalTemplateProps();

	const heading = $derived.by(() => {
		if (Cart.cartModalKind === undefined) {
			return "";
		}
		return cartModalHeadingMap[Cart.cartModalKind][tenant.locale];
	});
</script>

<Modal
	{heading}
	show={Cart.cartModalKind !== undefined}
	onclose={(): void => {
		Cart.closeCartModal();
	}}
	class="w-full max-w-116 md:max-w-138"
>
	{#if Cart.cartModalKind !== undefined}
		{@const Component = cartModalComponentMap[Cart.cartModalKind]}
		{void (/* @ts-expect-error We cannot handle the component map well */ "")}
		<Component {...Cart.cartModalProps} />
	{/if}
</Modal>
